import { MouseEvent } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TurnedInNotIcon from '@mui/icons-material/TurnedInNot';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

interface Props {
  isRegistered: boolean;
  onRegister?: (e?: MouseEvent<unknown>) => void;
  fullWidth?: boolean;
  registerLabel?: string;
  registerTooltip?: string;
  size?: 'small' | 'medium' | 'large';
}

const RegistrationAction = ({
  isRegistered,
  onRegister,
  fullWidth = false,
  registerLabel,
  registerTooltip,
  size = 'medium',
}: Props) => {
  const { t } = useTranslation();

  if (!onRegister) {
    return null;
  }

  // Chip only supports 'small' | 'medium', so map 'large' to 'medium'
  const chipSize = size === 'large' ? 'medium' : size;

  if (isRegistered) {
    return (
      <Chip
        icon={<CheckCircleIcon />}
        label={t('registrations.registered')}
        color="success"
        size={chipSize as 'small' | 'medium'}
        sx={fullWidth ? { width: '100%', justifyContent: 'center', py: 2.5 } : { px: 2, py: 1 }}
      />
    );
  }

  const buttonLabel = registerLabel ?? t('registrations.registerForEvent');
  const button = (
    <Button
      variant="contained"
      color="primary"
      fullWidth={fullWidth}
      startIcon={<TurnedInNotIcon />}
      onClick={onRegister}
      size={size}
      sx={{
        textTransform: 'none',
        fontWeight: 600,
        ...(fullWidth ? { py: 1 } : { px: 3 }),
      }}
    >
      {buttonLabel}
    </Button>
  );
  return registerTooltip ? (
    <Tooltip title={registerTooltip}>{button}</Tooltip>
  ) : (
    button
  );
};

export default RegistrationAction;

